import React from 'react';
import { Route, withRouter } from 'react-router-dom';

import PublicAuthenticationLayer from './PublicAuthenticationLayer';

import { PUBLIC_WIDGET_BASE_PATH } from '../../constants/paths';

const PublicWidgetLayout = (props) => {
  return (
    <Route path={PUBLIC_WIDGET_BASE_PATH} component={PublicAuthenticationLayer}/>
  );
}

export default withRouter(PublicWidgetLayout);
